import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Prompt } from "../Prompt";
import Tabs from "../Tabs";
import Header from "./Header";
import { HELP_AND_TIPS } from "../../constants/messages";

export const Help = ({ items, className }) => {
  const [headers, contents] = React.useMemo(
    () =>
      items.reduce(
        (acc, item) => {
          acc[0].push(item.name);
          acc[1].push(item.content);
          return acc;
        },
        [[], []]
      ),
    [items]
  );

  return (
    <Tabs className={classNames("mydpd-help", className)}>
      <Tabs.Navigation sm={4}>
        {headers.map((header, index) => (
          <Tabs.NavItem index={index} key={index}>
            {header}
          </Tabs.NavItem>
        ))}
      </Tabs.Navigation>
      <Tabs.Content sm={8}>
        {contents.map((content, index) => (
          <Tabs.ContentItem index={index} key={index}>
            <h5>{headers[index]}</h5>
            <div>{content}</div>
          </Tabs.ContentItem>
        ))}
      </Tabs.Content>
    </Tabs>
  );
};

Help.defaultProps = {
  items: [],
};

Help.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      content: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.string,
      ]),
    })
  ),
  className: PropTypes.string,
};

const Modal = ({ title, items, onClose, helpModalContainer, ...props }) => {
  const header = React.useMemo(() => {
    return <Header title={HELP_AND_TIPS} subtitle={title} />;
  }, [title]);

  return (
    <Prompt
      size="lg"
      className="mydpd-help-modal"
      type="info"
      header={header}
      withIcon={false}
      {...props}
      onClose={onClose}
    >
      <Help items={items} className={helpModalContainer} />
    </Prompt>
  );
};

export const HelpModalProps = (Modal.propTypes = {
  title: PropTypes.string,
  items: Help.propTypes.items,
  ...Prompt.propTypes,
});

Help.Modal = Modal;

export default Help;
